export default "__VITE_ASSET__HK2Y6T8E__"